<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header">
      <div class="row">
        <div class="col-12 col-sm-6 text-start mb3">{{ cardTitle }}</div>
        <div class="col-12 col-sm-6 text-end mb3">
          <button v-if="dataRow && !calculateLoader" type="button" @click="calculateContainer" class="btn btn-warning">تجميع القيم المالية</button>
          <loader v-if="dataRow && calculateLoader" />
        </div>
      </div>
    </div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />

    <mainLoader v-if="mainLoading" />
    <form v-else @submit.prevent="subimtData()">
      <!--begin::Body-->
      <div class="card-body">
        <div class="row steps-container">
          <div class="col" v-for="(title, index) in stepTitles" :key="index">
            <div class="steps" @click="jumbToStep(index + 1)">
              <span :class="{ active: step === index + 1 }">
                {{ title }}
              </span>
            </div>
          </div>
        </div>
        <!-- owner type -->
        <div v-if="step == 1">
          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label class="form-label" for="containerProjectId">المشروع العقاري:</label>
              <select id="containerProjectId" ref="projectsSelect" class="form-control" v-model="projectId" @change="setProject">
                <option :value="null">غير تابع لمشروع</option>
                <option v-for="project in projectsList" :key="project.id" :value="project.id">{{ project.title }}</option>
              </select>
              <div v-if="projectId" class="form-text">تم اختيار العميل والعنوان من بيانات المشروع.</div>
              <div v-if="projectSelectionNotice" class="form-text text-warning">{{ projectSelectionNotice }}</div>
              <router-link v-if="projectId && checkAccess('projects_read')" :to="`/projects/update/${projectId}`" class="d-inline-block mt-1">عرض المشروع</router-link>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label class="form-label" for="">العميل: <span class="req">*</span></label>
              <input type="text" class="form-control" placeholder="جوال العميل" @keyup="getClientData()" v-model="userMobile" :disabled="Boolean(projectId)">
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <loader v-if="userLoader" />
              <div v-if="userName">
                <label class="form-label" for="">اسم العميل:</label>
                <div>{{ userName }}</div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="form-head"><i class="bi bi-chevron-left"></i> البيانات الاساسية:</div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">نوع العقار: <span class="req">*</span></label>
              <select class="form-control" v-model="typeId">
                <option :value="null">اختر التصنيف</option>
                <option v-for="c in typesList" :value="c.id" :key="c.id">{{ c.name }}</option>
              </select>
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">وصف مختصر: <span class="req">*</span></label>
              <input type="text" class="form-control" v-model="title">
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="form-head"><i class="bi bi-chevron-left"></i> بيانات العنوان:</div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">المنطقة: <span class="req">*</span></label>
              <select class="form-control" v-model="regionId" @change="getCitiesList()" :disabled="Boolean(projectId)">
                <option v-for="(row, index) in regionsList" :value="row.id" :key="index">{{ row.name }}</option>
              </select>
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">المدينة: <span class="req">*</span></label>
              <select ref="citiesSelect" class="form-control" v-model="cityId" @change="getNeighborhoodsList()">
                <option v-for="(row, index) in citiesList" :value="row.id" :key="index">{{ row.name }}</option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">الحي: <span class="req">*</span></label>
              <select ref="neighborhoodsSelect" class="form-control" v-model="neighborhoodId" @change="changeMapMarker">
                <option v-for="(row, index) in neighborhoodsList" :value="row.id" :key="index">{{ row.name }}</option>
              </select>
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">الموقع على الخريطة:</label>
              <div ref="myMap" style="width: 100%; height: 350px;"></div>
              <div class="row pt-2">
                <div class="col">
                  <label for="" class="form-label">خط العرض - latitude</label>
                  <input type="number" class="form-control" step="0.000001" v-model="latitude" placeholder="latitude" @change="changeMarker()">
                </div>
                <div class="col">
                  <label for="" class="form-label">خط الطول - longitude</label>
                  <input type="number" class="form-control" step="0.000001" v-model="longitude" placeholder="longitude" @change="changeMarker()">
                </div>
              </div>
            </div>
          </div>

          <div v-if="dataRow" class="row">
            <div class="col"><hr></div>
          </div>
          <div v-if="dataRow" class="row">
            <div class="col">
              <div class="form-head"><i class="bi bi-chevron-left"></i> البيانات المالية:</div>
            </div>
          </div>
          <div v-if="dataRow" class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">ما تم تحصيله:</label>
              <div>{{ collectedAmount }}</div>
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">الدفعات المتبقية:</label>
              <div>{{ remainingPayments }}</div>
            </div>
          </div>
          <div v-if="dataRow" class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">الدفعات المتأخرة:</label>
              <div>{{ latePayments }}</div>
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">موعد الدفعة القادمة:</label>
              <div>{{ $shortDate(nextPayment) }}</div>
            </div>
          </div>
        </div>
        <div v-if="step == 2">
          <p class="text-muted">جميع البيانات في هذه النافذة اختيارية.</p>
          <div class="form-head"><i class="bi bi-chevron-left"></i> بيانات المياه:</div>
          <div class="row">
            <div class="col-sm-6 mb-3"><label class="form-label">فصل وحدات الماء</label><select class="form-control" v-model="additionals.waterSeparation"><option :value="null">غير محدد</option><option :value="true">نعم</option><option :value="false">لا</option></select></div>
            <div class="col-sm-6 mb-3"><label class="form-label">رقم حساب الماء</label><input class="form-control" v-model="additionals.waterAccountNumber" /></div>
            <div class="col-sm-6 mb-3"><label class="form-label">رقم عداد الماء</label><input class="form-control" v-model="additionals.waterMeterNumber" /></div>
          </div>
          <div class="form-head"><i class="bi bi-chevron-left"></i> بيانات الكهرباء:</div>
          <div class="row">
            <div class="col-sm-6 mb-3"><label class="form-label">رقم حساب الكهرباء</label><input class="form-control" v-model="additionals.electricityAccountNumber" /></div>
            <div class="col-sm-6 mb-3"><label class="form-label">رقم حساب عداد الكهرباء للمستأجر</label><input class="form-control" v-model="additionals.electricityTenantMeterAccount" /></div>
            <div class="col-sm-6 mb-3"><label class="form-label">رقم العداد</label><input class="form-control" v-model="additionals.electricityMeterNumber" /></div>
            <div class="col-sm-6 mb-3"><label class="form-label">رقم اشتراك العداد</label><input class="form-control" v-model="additionals.electricityMeterSubscription" /></div>
            <div class="col-sm-6 mb-3"><label class="form-label">رقم موقع عداد الكهرباء</label><input class="form-control" v-model="additionals.electricityMeterLocationNumber" /></div>
          </div>
          <div class="form-head"><i class="bi bi-chevron-left"></i> الكراج:</div>
          <div class="row">
            <div class="col-sm-6 mb-3"><label class="form-label">عدد الكراج</label><input type="number" min="0" class="form-control" v-model.number="additionals.garageCount" /></div>
            <div class="col-sm-6 mb-3"><label class="form-label">عدد ريموتات الكراج</label><input type="number" min="0" class="form-control" v-model.number="additionals.garageRemoteCount" /></div>
          </div>
          <div class="form-head"><i class="bi bi-chevron-left"></i> عقد الهيئة العامة للعقار:</div>
          <div class="row">
            <div class="col-sm-6 mb-3"><label class="form-label">رقم عقد الهيئة العامة للعقار</label><input class="form-control" v-model="additionals.regaContractNumber" /></div>
            <div class="col-sm-6 mb-3"><label class="form-label">تاريخ تجديد العقد الإلكتروني</label><input type="date" class="form-control" v-model="additionals.regaContractRenewalDate" /></div>
            <div class="col-sm-6 mb-3"><label class="form-label">تاريخ تجديد عقد إدارة الأملاك</label><input type="date" class="form-control" v-model="additionals.managementContractRenewalDate" /></div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-head"><i class="bi bi-chevron-left"></i> المستندات ورقم الصك:</div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">رقم الصك:</label>
              <input type="text" v-model="deedNumber" class="form-control">
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">صورة هوية المالك:</label>
              <input type="file" class="form-control" @change="setIdentityImage($event.target.files)">
              <img v-if="uploadedIdentityImage" :src="MEDIA_URL+uploadedIdentityImage" class="img-thumbnail" style="max-width: 200px;" alt="">
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">صورة رخصة البناء:</label>
              <input type="file" class="form-control" @change="setBuildingPermitImage($event.target.files)">
              <img v-if="uploadedBuildingPermitImage" :src="MEDIA_URL+uploadedBuildingPermitImage" class="img-thumbnail" style="max-width: 200px;" alt="">
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">صورة شهادة الدفاع المدني:</label>
              <input type="file" class="form-control" @change="setDefenseCertificateImage($event.target.files)">
              <img v-if="uploadedDefenseCertificateImage" :src="MEDIA_URL+uploadedDefenseCertificateImage" class="img-thumbnail" style="max-width: 200px;" alt="">
            </div>
          </div>

          <PropertyProfile v-if="dataRow" :containerId="dataRow.id" />
          <div v-else class="alert alert-info">يمكن إضافة بروفايل العقار بعد حفظ العقار متعدد الوحدات.</div>
          <div v-if="dataRow" class="text-end mt-3">
            <button type="submit" class="btn btn-success" :disabled="formLoader">حفظ البيانات الإضافية</button>
          </div>
        </div>
        <!-- images -->
        <div v-if="step == 3">
          <div class="row pb-3">
            <div class="col text-end">
              <button type="button" class="btn btn-success" data-bs-toggle="modal" data-bs-target="#uploadModal"><i class="bi bi-file-earmark-arrow-up"></i> إضافة صورة</button>
              <!-- Modal -->
              <div class="modal fade" id="uploadModal" tabindex="-1" aria-labelledby="uploadModalLabel" aria-hidden="true">
                <div class="modal-dialog">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h1 class="modal-title fs-5" id="uploadModalLabel">إضافة صورة</h1>
                      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                      <div class="row justify-content-center">
                        <div class="col-12 col-sm-8">
                          <input type="file" v-if="!mediaLoader" class="form-control" @change="uploadMedia($event.target.files)" multiple accept=".png,.jpg,.jpeg,.pmb,.webp">
                          <loader v-if="mediaLoader" />
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">اغلاق</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-3 media-img-container mb-3" v-for="(img, indx) in mediaList" :key="indx">
              <img :src="MEDIA_URL+img.path" class="img-thumbnail img-fluid" alt="">
              <button type="button" class="btn btn-danger btn-sm" @click="deleteMedia(img.id)"><i class="bi bi-trash"></i></button>
            </div>
          </div>
        </div>
        <!-- properties -->
        <div v-if="step == 4">
          <div v-if="!userId" class="row">
            <div class="col">
              <div class="alert alert-warning">يجب اختيار العميل في بيانات العقار لعرض العقارات</div>
            </div>
          </div>
          <mainLoader v-if="propertiesLoader && userId" />
          <div v-if="!propertiesLoader && userId" class="row">
            <div class="col">
              <div class="card card-secondary card-outline mb-4 mt-5">
                <div class="card-header"><div class="card-title">اختر الوحدات المدرجة تحت العقار</div></div>
                <div class="card-body">
                  <div class="row">
                    <div class="col">
                      <div class="table-responsive">
                        <table class="table table-striped">
                          <thead>
                            <tr>
                              <th>الاختيارات</th>
                              <th>الصورة</th>
                              <th>الوصف</th>
                              <th>النوع</th>
                              <th>المدينة</th>
                              <th>الحي</th>
                              <th>الحالة</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="row in propertiesRows" :key="row.id">
                              <td style="white-space: nowrap;">
                                <div class="form-check">
                                  <input class="form-check-input" type="checkbox" :value="row.id" v-model="propertyIds" :id="`property-check-${row.id}`">
                                  <label class="form-check-label" :for="`property-check-${row.id}`">اختيار</label>
                                  <router-link class="d-inline-block ms-2 fw-bold" :to="`/properties/update/${row.id}`">عقار رقم #{{ row.id }}</router-link>
                                </div>
                              </td>
                              <td>
                                <img v-if="row.mediaFiles && row.mediaFiles.length" :src="MEDIA_URL+row.mediaFiles[0].thumbnail" class="img-thumbnail" style="max-width: 150px;" alt="">
                              </td>
                              <td><router-link :to="`/properties/update/${row.id}`">{{ row.title }}</router-link></td>
                              <td>{{ (row.PropertyType)? row.PropertyType.name : 'غير معروف' }}</td>
                              <td>{{ (row.City)? row.City.name : 'غير معروف' }}</td>
                              <td>{{ (row.Neighborhood)? row.Neighborhood.name : 'غير معروف' }}</td>
                              <td>{{ statusTranslate[row.status] }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <div class="row">
                    <div class="col">
                      <ul class="pagination">
                        <li v-if="currentPage > 1" class="page-item"><a class="page-link" href="#" @click.prevent="prevPage()">السابق</a></li>
                        <a class="page-link active" href="javascript:void(0)">{{ currentPage }}</a>
                        <li v-if="propertiesRows.length >= 30" class="page-item"><a class="page-link" href="#" @click.prevent="nextPage()">التالي</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="step == 5">
          <PropertyAttachments v-if="dataRow" :containerId="dataRow.id" />
          <div v-else class="alert alert-info">يجب حفظ العقار المتعدد أولاً قبل إضافة المرفقات</div>
        </div>
      </div>
      <!--end::Body-->
      <!--begin::Footer-->
      <div class="card-footer">
        <div class="row">
          <div class="col text-start">
            <button v-if="step > 1" type="button" class="btn btn-secondary" @click="prevStep"><i class="bi bi-arrow-bar-right"></i> السابق</button>
          </div>
          <div class="col text-end">
            <button v-if="step < stepTitles.length" type="button" class="btn btn-secondary" @click="nextStep">التالي <i class="bi bi-arrow-bar-left"></i></button>
            <button v-if="step == stepTitles.length && !formLoader" type="submit" class="btn btn-success">ارسل</button>
            <loader v-if="step == stepTitles.length && formLoader" />
          </div>
        </div>
      </div>
      <!--end::Footer-->
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { toast, shortDate, checkAccess } from '@/helpers/tools';
import PropertyAttachments from '@/components/PropertyAttachments.vue';
import $ from 'jquery';
window.$ = $;
window.jQuery = $;
import 'select2';
import 'select2/dist/css/select2.min.css';
import PropertyProfile from '@/components/PropertyProfile.vue';

export default {
  name: 'PropertyContainersForm',
  components: { PropertyAttachments, PropertyProfile },
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      mainLoading: true,
      userLoader: false,
      mediaLoader: false,
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      step: 1,
      stepTitles: ["بيانات العقار", "البيانات الإضافية", "الصور", "الوحدات", "مرفقات العقار"],
      // for config
      regionsList: [],
      typesList: [],
      userMobile: null,
      userName: null,
      citiesList: [],
      neighborhoodsList: [],
      mediaList: [],
      uploadedIdentityImage: null,
      uploadedBuildingPermitImage: null,
      uploadedDefenseCertificateImage: null,
      userId: null,
      projectId: null,
      projectsList: [],
      projectSelectionNotice: '',
      identityImage: null,
      buildingPermitImage: null,
      defenseCertificateImage: null,
      regionId: null,
      cityId: null,
      neighborhoodId: null,
      deedNumber: '',
      typeId: null,
      title: '',
      latitude: 24.7136,
      longitude: 46.6753,
      mediaIds: [],
      propertyIds: [],
      map: null,
      marker: null,
      collectedAmount: 0,
      remainingPayments: 0,
      nextPayment: null,
      latePayments: 0,
      // user properites
      propertiesLoader: true,
      propertiesRows: [],
      currentPage: 1,
      statusTranslate: {},
      calculateLoader: false,
      additionals: {waterSeparation: null, waterAccountNumber: '', waterMeterNumber: '', electricityAccountNumber: '', electricityTenantMeterAccount: '', electricityMeterNumber: '', electricityMeterSubscription: '', electricityMeterLocationNumber: '', garageCount: null, garageRemoteCount: null, regaContractNumber: '', regaContractRenewalDate: '', managementContractRenewalDate: ''},
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL', 'GOOGLE_MAP_API'])
  },
  watch: {
    mainLoading(loading){
      if(loading) this.destroyFormSelect2();
      else this.applyFormSelect2();
    },
    step(){
      this.destroyFormSelect2();
      this.applyFormSelect2();
    },
    projectsList(){ this.applySelect2Projects(); },
    projectId(){ this.applySelect2Projects(); },
    citiesList(){ this.applySelect2Cities(); },
    cityId(){ this.applySelect2Cities(); },
    neighborhoodsList(){ this.applySelect2Neighborhoods(); },
    neighborhoodId(){ this.applySelect2Neighborhoods(); },
  },
  mounted(){
    this.applyFormSelect2();
  },
  beforeUnmount(){
    this._select2Disposed = true;
    this.destroyFormSelect2();
  },
  methods: {
    checkAccess,
    setProject(){
      const project = this.projectsList.find(row => row.id == this.projectId);
      this.projectSelectionNotice = '';
      this.currentPage = 1;
      if(project && this.propertyIds.length && (this.userId != project.userId || this.regionId != project.regionId)){
        this.propertyIds = [];
        this.projectSelectionNotice = 'تم إلغاء اختيار الوحدات لاختلاف العميل أو المنطقة. يمكنك اختيار وحدات متوافقة من تبويب الوحدات.';
      }
      if(!project){
        if(this.userMobile) this.getClientData();
        return;
      }
      this.userId = project.userId;
      this.userMobile = project.User?.mobile || null;
      this.userName = project.User?.name || null;
      this.regionId = project.regionId;
      this.cityId = project.cityId;
      this.neighborhoodId = project.neighborhoodId;
      this.getCitiesList(false);
      this.getNeighborhoodsList(false);
      if(this.userMobile) this.getClientData();
      else this.getUserProperties();
    },
    prevStep(){
      this.step = this.step - 1;
      if(this.step == 1){
        this.initialGoogleMap();
      }
    },
    nextStep(){
      this.hasError = false;
      this.errorNumber = 0;
      if(this.step == 1){
        if(!this.userId){
          this.message = 'يجب اختيار العميل';
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        if(!this.typeId){
          this.message = 'يجب اختيار نوع العقار';
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        if(!this.title || this.title.trim() == ''){
          this.message = 'يجب ادخال الوصف المتخصر';
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        if(!this.regionId){
          this.message = 'يجب اختيار المنطقة';
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        if(!this.cityId){
          this.message = 'يجب اختيار المدينة';
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        if(!this.neighborhoodId){
          this.message = 'يجب اختيار الحي';
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
      }
      this.step = this.step + 1;
    },
    getInitData(){
      this.$http.get('/api/admin/propertyContainers/init').then(({data}) => {
        this.regionsList = data.regionsList;
        this.typesList = data.typesList;
        this.projectsList = data.projectsList || [];
        if(!this.dataRow && this.$route.query.projectId){
          const project = this.projectsList.find(row => row.id == this.$route.query.projectId);
          if(project){
            this.projectId = project.id;
            this.setProject();
          }
        }
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    getUserProperties(){
      if(!this.userId)
        return;
      this.propertiesLoader = true;
      const requestUserId = this.userId;
      const requestProjectId = this.projectId;
      let filterQuery = `page=${this.currentPage}`;
      filterQuery += `&projectId=${this.projectId ? encodeURIComponent(this.projectId) : 'null'}`;
      if(this.dataRow) filterQuery += `&containerId=${this.dataRow.id}`;
      if(this.neighborhoodId) filterQuery += `&neighborhoodId=${this.neighborhoodId}`;
      else if(this.cityId) filterQuery += `&cityId=${this.cityId}`;
      this.$http.get(`/api/admin/propertyContainers/getProperties/${this.userId}?${filterQuery}`).then(({data}) => {
        if(this.userId != requestUserId || this.projectId != requestProjectId) return;
        this.propertiesRows = data.rows;
        this.statusTranslate = data.propertyStatus;
        this.propertiesLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    nextPage(){
      this.currentPage += 1;
      this.getUserProperties();
    },
    prevPage(){
      this.currentPage -= 1;
      this.getUserProperties();
    },
    getClientData(){
      if(this.userMobile && this.userMobile.length >= 10){
        this.hasError = false;
        this.hasSucess = false;
        this.userLoader = true;
        const requestMobile = this.userMobile.trim();
        const requestProjectId = this.projectId;
        this.userId = null;
        this.userName = null;
        this.$http.post('/api/admin/users/getUser', {
          mobile: requestMobile,
        }).then(({data}) => {
          if(this.userMobile?.trim() !== requestMobile || this.projectId != requestProjectId) return;
          this.userId = data.user.id;
          this.userName = data.user.name;
          this.userLoader = false;
          this.getUserProperties();
        }).catch(err => {
          if(this.userMobile?.trim() !== requestMobile || this.projectId != requestProjectId) return;
          [this.message, this.errorNumber] = this.$globalError(err, true);
          this.hasError = true;
          this.userLoader = false;
          // window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }
    },
    getCitiesList(change=true){
      this.hasError = false;
      this.citiesList = [];
      this.neighborhoodsList = [];
      if(change){
        this.cityId = null;
        this.neighborhoodId = null;
      }
      if(!this.regionId){
        return;
      }
      const requestRegionId = this.regionId;
      this.$http.get(`/api/admin/cities/list?regionId=${this.regionId}&all=1`).then(({data}) => {
        if(this._select2Disposed || this.regionId != requestRegionId) return;
        this.citiesList = data.cities;
      }).catch(err => {
        if(this._select2Disposed || this.regionId != requestRegionId) return;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    getNeighborhoodsList(change=true){
      this.hasError = false;
      this.neighborhoodsList = [];
      if(change){
        this.neighborhoodId = null;
        this.getUserProperties();
        this.propertyIds = [];
      }
      if(!this.cityId){
        return;
      }
      const requestCityId = this.cityId;
      this.$http.get(`/api/admin/neighborhoods/list?cityId=${this.cityId}&all=1`).then(({data}) => {
        if(this._select2Disposed || this.cityId != requestCityId) return;
        this.neighborhoodsList = data.neighborhoods;
      }).catch(err => {
        if(this._select2Disposed || this.cityId != requestCityId) return;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    async uploadMedia(files){
      this.mediaLoader = true;
      for(let i=0; i<files.length; i++){
        const formData = new FormData();
        formData.append('file', files[i]);
        try {
          const mFile = await this.$http.post('/api/admin/propertyContainers/media/upload', formData);
          if(mFile){
            this.mediaIds.push(mFile.data.mediaId);
            this.mediaList.push({
              id: mFile.data.mediaId,
              path: mFile.data.filePath,
            });
          }
        }catch(err){
          // console.log(err);
        }
      }
      this.mediaLoader = false;
      toast('تم رفع الصور بنجاح', 'success');
    },
    deleteMedia(id){
      this.$swal.fire({
        title: "هل تريد تأكيد حذف الصورة؟",
        showCancelButton: true,
        confirmButtonText: "حذف",
        cancelButtonText: "إلغاء",
        confirmButtonColor: '#dc3741',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$http.delete(`/api/admin/propertyContainers/media/delete/${id}`).then(({data}) => {
            this.mediaIds.splice(this.mediaIds.indexOf(id), 1);
            let mediaArray = [];
            this.mediaList.map(m => {
              if(m.id != id)
                mediaArray.push(m);
            });
            this.mediaList = mediaArray;
            toast('تم حذف الصورة بنجاح', 'success');
          }).catch(err => {
            toast('غير قادر على حذف الصورة');
          });
        }
      });
    },
    subimtData(){
      const savedStep = this.step;
      this.formLoader = true;
      this.hasError = false;
      this.hasSucess = false;

      const formData = new FormData();
      formData.append('userId', this.userId);
      formData.append('typeId', this.typeId);
      formData.append('regionId', this.regionId);
      formData.append('cityId', this.cityId);
      formData.append('neighborhoodId', this.neighborhoodId);
      formData.append('title', this.title);
      formData.append('latitude', this.latitude);
      formData.append('longitude', this.longitude);
      formData.append('deedNumber', this.deedNumber || '');
      formData.append('projectId', this.projectId || '');
      Object.entries(this.additionals).forEach(([field, value]) => formData.append(field, value === null || value === undefined ? '' : value));
      if(this.identityImage) formData.append('identityImage', this.identityImage);
      if(this.buildingPermitImage) formData.append('buildingPermitImage', this.buildingPermitImage);
      if(this.defenseCertificateImage) formData.append('defenseCertificateImage', this.defenseCertificateImage);
      formData.append('mediaIds', JSON.stringify(this.mediaIds));
      formData.append('propertyIds', JSON.stringify(this.propertyIds));

      let api = null;
      if(this.dataRow)
        api = this.$http.put(`/api/admin/propertyContainers/update/${this.dataRow.id}`, formData);
      else
        api = this.$http.post('/api/admin/propertyContainers/create', formData);
      api.then(({data}) => {
        if(!this.dataRow){
          toast('تم إضافة الإعلان بنجاح', 'success');
          this.$router.replace('/propertyContainers').catch(() => {});
        }else{
          this.message = 'تم التعديل بنجاح';
          this.hasSucess = true;
          this.step = savedStep;
          if(this.step === 1) this.initialGoogleMap();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
    // google map 
    initMap(){
      if (!this.$refs.myMap) {
        setTimeout(() => this.initMap(), 200);
        return;
      }
      if (!window.google) {
        console.error("Google Maps API is not loaded.");
        return;
      }

      // Initialize Map
      this.map = new google.maps.Map(this.$refs.myMap, {
        center: { lat: this.latitude ?? 24.7136, lng: this.longitude ?? 46.6753 },
        zoom: 8,
      });

      // Create a Marker
      this.marker = new google.maps.Marker({
        position: { lat: this.latitude ?? 24.7136, lng: this.longitude ?? 46.6753 },
        map: this.map,
        draggable: true, // Allow dragging the marker
      });

      // Update lat/lng when marker is moved
      this.marker.addListener("dragend", () => {
        const pos = this.marker.getPosition();
        this.latitude = pos.lat();
        this.longitude = pos.lng();
      });

      // Click on the map to set a new marker position
      this.map.addListener("click", (event) => {
        this.latitude = event.latLng.lat();
        this.longitude = event.latLng.lng();
        this.marker.setPosition(event.latLng);
      });
    },
    initialGoogleMap(){
      if (!window.google) {
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.GOOGLE_MAP_API}&loading=async&libraries=places&callback=initMap`;
        script.async = true;
        document.head.appendChild(script);
        window.initMap = this.initMap;
      } else {
        this.initMap();
      }
    },
    changeMarker(){
      const newPosition = new google.maps.LatLng(this.latitude, this.longitude);
      this.marker.setPosition(newPosition);
      this.map.setCenter(newPosition);
    },
    changeMapMarker(){
      if(this.neighborhoodId){
        for(let i=0; i<this.neighborhoodsList.length; i++){
          if(this.neighborhoodsList[i].id == this.neighborhoodId){
            const lat = parseFloat(this.neighborhoodsList[i].latitude);
            const lng = parseFloat(this.neighborhoodsList[i].longitude);
            if(lat && lng){
              this.latitude = lat;
              this.longitude = lng;
              this.changeMarker();
            }
          }
        }
      }
      this.getUserProperties();
      this.propertyIds = [];
    },
    jumbToStep(stepNum){
      if(this.dataRow){
        this.step = stepNum;
        if(stepNum == 1){
          this.initialGoogleMap();
        }
      }
    },
    setIdentityImage(files){
      this.identityImage = files[0];
    },
    setBuildingPermitImage(files){
      this.buildingPermitImage = files[0];
    },
    setDefenseCertificateImage(files){
      this.defenseCertificateImage = files[0];
    },
    calculateContainer(){
      this.calculateLoader = true;
      this.$http.get(`/api/admin/propertyContainers/calculateContainer/${this.dataRow.id}`).then(({data}) => {
        this.collectedAmount = data.row.collectedAmount;
        this.remainingPayments = data.row.remainingPayments;
        this.nextPayment = data.row.nextPayment;
        this.latePayments = data.row.latePayments;
        this.calculateLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    applyFormSelect2(){
      this.applySelect2Projects();
      this.applySelect2Cities();
      this.applySelect2Neighborhoods();
    },
    applySelect2Field(refName, value, onChange){
      this.$nextTick(() => {
        if(this._select2Disposed || !this.$refs[refName]) return;
        const $el = $(this.$refs[refName]);
        if(!$el.hasClass('select2-hidden-accessible')){
          $el.select2({ width: '100%', dir: 'rtl' });
        }
        $el.off(`change.${refName}2`);
        const emptyOption = Array.from($el[0].options).find(option => option.value === '' || (Object.hasOwn(option, '_value') && option._value == null));
        $el.val(value == null || value === '' ? (emptyOption ? emptyOption.value : null) : value).trigger('change.select2');
        $el.on(`change.${refName}2`, function(){
          const selected = Number($(this).val());
          onChange(Number.isSafeInteger(selected) && selected > 0 ? selected : null);
        });
      });
    },
    destroyFormSelect2(){
      ['projectsSelect', 'citiesSelect', 'neighborhoodsSelect'].forEach(refName => {
        const $el = $(this.$refs[refName]);
        $el.off(`change.${refName}2`);
        if($el.hasClass('select2-hidden-accessible')) $el.select2('destroy');
      });
    },
    applySelect2Projects(){
      this.applySelect2Field('projectsSelect', this.projectId, value => {
        if(this.projectId == value) return;
        this.projectId = value;
        this.setProject();
      });
    },
    applySelect2Cities(){
      this.applySelect2Field('citiesSelect', this.cityId, value => {
        if(this.cityId == value) return;
        this.cityId = value;
        this.getNeighborhoodsList();
      });
    },
    applySelect2Neighborhoods(){
      this.applySelect2Field('neighborhoodsSelect', this.neighborhoodId, value => {
        if(this.neighborhoodId == value) return;
        this.neighborhoodId = value;
        this.changeMapMarker();
      });
    },
  },
  created(){
    if(this.dataRow){
      // for config
      this.userMobile = (this.dataRow.User)? this.dataRow.User.mobile : null;
      this.userName = (this.dataRow.User)? this.dataRow.User.name : null;
      this.uploadedIdentityImage = this.dataRow.identityImage;
      this.uploadedBuildingPermitImage = this.dataRow.buildingPermitImage;
      this.uploadedDefenseCertificateImage = this.dataRow.defenseCertificateImage;
      if(this.dataRow.PropertyContainerMedia){
        this.dataRow.PropertyContainerMedia.map(m => {
          this.mediaList.push({
            id: m.id,
            path: m.filePath,
          });
          this.mediaIds.push(m.id);
        });
      }
      if(this.dataRow.Properties){
        this.dataRow.Properties.map(m => {
          this.propertyIds.push(m.id);
        });
      }
      this.userId = this.dataRow.userId;
      this.regionId = this.dataRow.regionId;
      this.cityId = this.dataRow.cityId;
      this.neighborhoodId = this.dataRow.neighborhoodId;
      this.deedNumber = this.dataRow.deedNumber || '';
      this.projectId = this.dataRow.projectId || null;
      Object.keys(this.additionals).forEach(field => { this.additionals[field] = this.dataRow[field] ?? this.additionals[field]; });
      this.typeId = this.dataRow.typeId;
      this.title = this.dataRow.title;
      this.latitude = (this.dataRow.latitude)? parseFloat(this.dataRow.latitude) : null;
      this.longitude = (this.dataRow.longitude)? parseFloat(this.dataRow.longitude) : null;
      this.collectedAmount = this.dataRow.collectedAmount;
      this.remainingPayments = this.dataRow.remainingPayments;
      this.nextPayment = this.dataRow.nextPayment;
      this.latePayments = this.dataRow.latePayments;

      this.getCitiesList(false);
      this.getNeighborhoodsList(false);
      this.getUserProperties();
    }

    this.getInitData();
    this.initialGoogleMap();
    this.applySelect2Cities();
    this.applySelect2Neighborhoods();
  }
}
</script>

<style scoped>
.steps-container {
  margin-bottom: 40px;
}
.steps {
  display: flex;
  justify-content: space-around;
  white-space: nowrap;
  font-weight: bold;
  cursor: pointer;
}

.steps span {
  padding: 5px 15px;
  border-bottom: 3px solid #ccc;
}

.steps .active {
  color: #007bff;
  border-bottom: 3px solid #007bff;
}
</style>